export * from "./auth";
export var InputAction;

(function (InputAction) {
  InputAction[InputAction["ADD"] = 0] = "ADD";
  InputAction[InputAction["DELETE"] = 1] = "DELETE";
})(InputAction || (InputAction = {}));